import "./style.scss";

export function setUpSliderLP(selector = "", sliderHtml, options = {}) {
  if ($(`${selector} .slider-landingpage .flex-box.slider-nav`).hasClass("slick-slider")) {
    $(`${selector} .slider-landingpage .flex-box.slider-nav`).slick('unslick')
  }
  $(`${selector} .slider-landingpage .flex-box`).html(sliderHtml)
  setTimeout(() => {
    $(`${selector} .slider-landingpage .flex-box.slider-nav`).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      lazyLoad: 'ondemand',
      nextArrow: `<img class="slick-next slick-arrow" alt="icon" src="${require("../../../../assets/images/icons/nextArrow_light.svg")}" />`,
      prevArrow: `<img class="slick-prev slick-arrow" alt="icon" src="${require("../../../../assets/images/icons/prevArrow_light.svg")}" />`,
      ...options
    });
  }, 0);
}